module.exports = __webpack_public_path__ + "static/media/sf-trial-3-wrong.2857b403.mp3";